module.exports = __webpack_public_path__ + "img/suolo.854521a8.png";